import colors from "../theme/colors";

export const getCustomColorFont = (background: string, enable?: boolean) => {
  background = background.substring(1); // remove #
  let rgb = parseInt(background, 16);   // convert rgb to hexadecimal
  let r = (rgb >> 16) & 0xff;  // extract red
  let g = (rgb >>  8) & 0xff;  // extract green
  let b = (rgb >>  0) & 0xff;  // extract blue

  let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  if (luma < 200) {
      return colors.white;
  }
  
  return colors.title;
}